import { defineEffect } from '../../../core/effect';
import { battleSpec } from '../fx/battle';

/** ダメージ計算（直接攻撃）（Issue #589。状況は共通側の `editorPorts/duelSituations/battle.js` が決め、絵の組み立ては `../fx/battle.js`） */
export default defineEffect({ situation: 'battle_direct', role: 'motion', ...battleSpec(true) }, 'battle_direct_motion.js');
